import { useTrackStorefrontImpression } from '@hooks/useTrackStorefrontImpression';
import { TextBody, TextSubhead } from '@tkww/orion-web-ds-text';
import React from 'react';
import { Sparkle } from './Sparkle';
import Styles from './styles.scss';
interface ReviewsAISummaryProps {
	reviewSummary: string;
}

const ReviewAISummary: React.FC<ReviewsAISummaryProps> = ({
	reviewSummary,
}) => {
	const impressionRef = useTrackStorefrontImpression('Review AI Summary');
	return (
		<div className={Styles.reviewAiSummary} data-testid="review-ai-summary">
			<div className={Styles.reviewAiSummaryTitle}>
				<Sparkle monochrome="black" size={'24'} />
				<TextSubhead ref={impressionRef} as="h2" bold>
					Review Summary
				</TextSubhead>
			</div>
			<TextBody size="sm" className={Styles.reviewAiSummarySubtitle}>
				This AI-generated summary is a snapshot of this vendor's ratings and
				feedback.
			</TextBody>
			{reviewSummary}
		</div>
	);
};

export default ReviewAISummary;
